export default "__VITE_ASSET__d8bad198__"